import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './pages/App';
import './index.css';

import reportWebVitals from './reportWebVitals';
import { AuthContextProvider } from './contexts/AuthContext';
import { PageContextProvider } from './contexts/PageContext';
import { appTheme } from './themes/Theme';

import { ThemeProvider } from '@mui/material/styles';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ThemeProvider theme={appTheme}>
    <AuthContextProvider>
      <PageContextProvider>
        <App />
      </PageContextProvider>
    </AuthContextProvider>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
